import script from "./AppLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogo.vue?vue&type=script&setup=true&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=f3c77aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c77aae"]])

export default __exports__